const onEnter = (func) => (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    return func();
  }
};

export default onEnter;
